import { DeferredPromise, WebWorkerRunner, experimentToRuns, prepareExperiment, } from "..";
export class WebExperimentRunner {
    constructor(numWorkers, devMode, fileName) {
        this.workers = new Map();
        this.simulationRunQueue = new Set();
        this.devMode = false;
        this.runningQueue = false;
        this.devMode = devMode;
        for (let idx = 0; idx < numWorkers; idx++) {
            const workerId = `worker-web-${idx}`;
            const runner = new WebWorkerRunner(workerId, fileName, devMode);
            if (devMode) {
                console.log("Spinning up worker", workerId);
            }
            this.workers.set(workerId, runner);
        }
    }
    async handleRequest(req, simulationRunId) {
        throw new Error("Single-actions are not supported (yet) with experiments");
    }
    async queueExperiment(src) {
        const experiment = prepareExperiment(src);
        const runs = experimentToRuns(experiment, src.pyodideEnabled);
        const runQueue = Object.fromEntries([...runs].map((run) => [
            run.presetRunId ?? "",
            [run, new DeferredPromise(), new DeferredPromise()],
        ]));
        for (const req of Object.values(runQueue)) {
            this.simulationRunQueue.add(req);
        }
        const runPromises = Object.fromEntries(Object.entries(runQueue).map(([runId, [, runnerProm]]) => [
            runId,
            runnerProm,
        ]));
        const startedPromises = Object.fromEntries(Object.entries(runQueue).map(([runId, [, , startedProm]]) => [
            runId,
            startedProm,
        ]));
        const experimentPromise = new DeferredPromise();
        Promise.all(Object.values(runPromises))
            .then((_) => experimentPromise.resolve())
            .catch((why) => { });
        this.kick().catch((err) => console.error(err));
        const { manifest: _, queuedSimulationRunIds: __, ...run } = experiment;
        return {
            ...run,
            experimentPromise,
            runPromises,
            startedPromises,
        };
    }
    async kick() {
        if (this.runningQueue) {
            return;
        }
        this.runningQueue = true;
        const futs = [];
        for (const [, worker] of this.workers) {
            const act = async () => {
                let init = this.simulationRunQueue.values().next().value;
                while (init !== undefined) {
                    this.simulationRunQueue.delete(init);
                    init[2].resolve();
                    const newStatus = await worker.handleRequest(init[0]);
                    const prom = init[1];
                    prom.resolve(newStatus);
                    init = this.simulationRunQueue.values().next().value;
                }
                this.runningQueue = false;
            };
            futs.push(act());
        }
        return Promise.all(futs);
    }
}
//# sourceMappingURL=web-runner.js.map